import { CardShell } from '@/components/cards/common';
import { ShowPerformanceTable } from '@/components/tables/ShowPerformanceTable';
import { usePayoutShowsQuery } from '@/services/revenueApi';
import { SelectedNetwork } from '@/types';

type Props = {
  selectedNetwork: SelectedNetwork;
  year: string;
  month: string;
};

export const ShowsCard = ({ selectedNetwork, year, month }: Props) => {
  const { isPending, data } = usePayoutShowsQuery(selectedNetwork.id, year, month);

  return (
    <CardShell className="col-span-12 h-full" title="Shows">
      <ShowPerformanceTable isLoading={isPending} data={data} type="payouts" />
    </CardShell>
  );
};
